var __hasProp = {}.hasOwnProperty,
  __extends = function(child, parent) { for (var key in parent) { if (__hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; };

define(['jquery', 'backbone', 'template/editing.htm'], function($, Backbone, editingTemplate) {
  var EditingToolbarView;
  return EditingToolbarView = (function(_super) {

    __extends(EditingToolbarView, _super);

    function EditingToolbarView() {
      EditingToolbarView.__super__.constructor.apply(this, arguments);
    }

    EditingToolbarView.prototype.className = 'editing-toolbar';

    EditingToolbarView.prototype.events = {
      'click .confirm-yes': 'confirmYes',
      'click .confirm-no': 'confirmNo'
    };

    EditingToolbarView.prototype.actions = [];

    EditingToolbarView.prototype.animationTime = 500;

    EditingToolbarView.prototype.confirmYes = function() {
      if (typeof this.onConfirm === "function") {
        this.onConfirm();
      }
      return this.hideConfirmation();
    };

    EditingToolbarView.prototype.confirmNo = function() {
      return this.hideConfirmation();
    };

    EditingToolbarView.prototype.initialize = function(options) {
      this.actions = options.actions;
      this.context = options.context;
      return this.render();
    };

    EditingToolbarView.prototype.render = function() {
      var action, _fn, _i, _len, _ref,
        _this = this;
      this.$el.html(_.template(editingTemplate, {
        message: ""
      }));
      _ref = this.actions;
      _fn = function(action) {
        var itemTemplate;
        itemTemplate = $("<div class='editing-action " + action.name + " " + action.icon + "'></div>");
        if (action.callback) {
          itemTemplate.on('click', function() {
            var actionCall;
            actionCall = function() {
              return action.callback.apply(_this.context);
            };
            if (action.withConfirmation) {
              _this.showConfirmation(action.message);
              return _this.onConfirm = actionCall;
            } else {
              return actionCall();
            }
          });
        }
        return _this.$el.append(itemTemplate);
      };
      for (_i = 0, _len = _ref.length; _i < _len; _i++) {
        action = _ref[_i];
        _fn(action);
      }
      return setTimeout(function() {
        return _this.$el.addClass('active');
      }, 50);
    };

    EditingToolbarView.prototype.showConfirmation = function(message) {
      this.$el.addClass('extended');
      this.$el.find('.editing-action').hide();
      this.$el.find('.editing-confirmation').replaceWith(_.template(editingTemplate, {
        message: message
      }));
      return this.$el.find('.editing-confirmation').show();
    };

    EditingToolbarView.prototype.hideConfirmation = function() {
      this.$el.removeClass('extended');
      this.$el.find('.editing-action').show();
      return this.$el.find('.editing-confirmation').hide();
    };

    EditingToolbarView.prototype.remove = function() {
      var _this = this;
      this.$el.removeClass('active');
      return setTimeout(function() {
        return EditingToolbarView.__super__.remove.apply(_this, arguments);
      }, this.animationTime);
    };

    return EditingToolbarView;

  })(Backbone.View);
});
